// Reports (wave 3, tab host as the approved boards draw it): the tabs the
// person's role may see, in the same order and with the same role gates as
// before. The theme draws the selected tab (orange words, 2-px line); only
// the open tab is mounted, so each report reads only when it is opened.
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DriverEarning from './DriverEarning';
import Earningreports from './Earningreports';
import FleetAdminEarning from './FleetAdminEarning';
import FleetDriversReport from './FleetDriversReport';
import ContactSyncReport from './ContactSyncReport';
import { tokens as c } from '../theme';
import { calmCaps } from '../components/modern';

export default function AllReports() {
  const auth = useSelector((state) => state.auth);
  const { t, i18n } = useTranslation();

  // Build tabs array based on user role
  const tabs = React.useMemo(() => {
    const userType = auth.profile.usertype;
    const tabsList = [];

    // Tab 0: Driver Earning (fleetadmin, admin, finance)
    if (userType === 'fleetadmin' || userType === 'admin' || userType === 'finance') {
      tabsList.push({ key: 'driver_earning', label: t('driver_earning'), component: <DriverEarning /> });
    }

    // Tab 1: Earning Reports (admin, finance)
    if (userType === 'admin' || userType === 'finance') {
      tabsList.push({ key: 'earning_reports', label: t('earning_reports'), component: <Earningreports /> });
    }

    // Tab 2: Fleet Admin Earning Reports (admin, finance)
    if (userType === 'admin' || userType === 'finance') {
      tabsList.push({ key: 'fleetadmin_earning', label: t('fleetadmin_earning_reports'), component: <FleetAdminEarning /> });
    }

    // Tab 3: Fleet Drivers Report (admin, finance, fleetadmin, callcenteragent, callcentersupervisor)
    if (userType === 'admin' || userType === 'finance' || userType === 'fleetadmin' || userType === 'callcenteragent' || userType === 'callcentersupervisor') {
      tabsList.push({ key: 'fleet_drivers', label: t('fleet_drivers_report', { defaultValue: 'Scout Onboarding Report' }), component: <FleetDriversReport /> });
    }

    // Tab 4: Contact Sync Report (admin only)
    if (userType === 'admin') {
      tabsList.push({ key: 'contact_sync', label: t('contact_sync_report'), component: <ContactSyncReport /> });
    }

    return tabsList;
  }, [auth.profile.usertype, t]);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (!tabs.length) return null;
  const current = Math.min(value, tabs.length - 1);

  return (
    <Box dir={i18n.dir()} sx={{ width: '100%' }}>
      <Tabs
        value={current}
        onChange={handleChange}
        aria-label={calmCaps(t('report', { defaultValue: 'Reports' }))}
        variant="scrollable"
        allowScrollButtonsMobile
        sx={{ borderBottom: `1px solid ${c.OUTLINE}` }}
      >
        {tabs.map((tab, index) => (
          <Tab key={tab.key} label={calmCaps(tab.label)} id={`simple-tab-${index}`} aria-controls={`simple-tabpanel-${index}`} />
        ))}
      </Tabs>
      <Box role="tabpanel" id={`simple-tabpanel-${current}`} aria-labelledby={`simple-tab-${current}`} sx={{ pt: 2.5 }}>
        {tabs[current].component}
      </Box>
    </Box>
  );
}
